import { render, staticRenderFns } from "./webhook.vue?vue&type=template&id=70b96b5a"
import script from "./webhook.vue?vue&type=script&lang=js"
export * from "./webhook.vue?vue&type=script&lang=js"
import style0 from "./webhook.vue?vue&type=style&index=0&id=70b96b5a&prod&lang=css"
import style1 from "./webhook.vue?vue&type=style&index=1&id=70b96b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports